import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: theme.spacing(3),
    marginBottom: theme.spacing(4),
  },
  horizontalDivider: {
    height: '1px',
    backgroundColor: theme.palette.dividerV2.main,
    marginLeft: theme.spacing(-4),
    marginRight: theme.spacing(-4),
  },
  cardHeadingWrapper: {
    gap: theme.spacing(2),
  },
  designCards: {
    height: theme.spacing(4),
    backgroundColor: theme.palette.textBackground.light,
    width: '100%',
    paddingLeft: theme.spacing(8),
    marginLeft: '-32px',
  },
}))
